export default "__VITE_ASSET__nG_t8w4K__"